unit View.Sincronizacao_Logs.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewSincronizacao_LogsEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbsincronizacao_service_id: TLabel;
    edsincronizacao_service_id: TDBEdit;
    lbultima_sincronizacao: TLabel;
    edultima_sincronizacao: TDBEdit;
    lbinicio_sincronizacao: TLabel;
    edinicio_sincronizacao: TDBEdit;
    lbfim_sincronizacao: TLabel;
    edfim_sincronizacao: TDBEdit;
    lbsincronizacao_erro: TLabel;
    edsincronizacao_erro: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbtempo_sincronizacao: TLabel;
    edtempo_sincronizacao: TDBEdit;
    lbsincronizacao_rota: TLabel;
    edsincronizacao_rota: TDBEdit;
    XDataClientSincronizacao_LogsGet: TXDataWebClient;
    XDataClientSincronizacao_LogsDelete: TXDataWebClient;
    Sincronizacao_LogsDataset: TXDataWebDataSet;
    Sincronizacao_LogsDatasetid: TIntegerField;
    Sincronizacao_LogsDatasetaliado_id: TIntegerField;
    Sincronizacao_LogsDatasetdata_base_id: TIntegerField;
    Sincronizacao_LogsDatasetsincronizacao_service_id: TIntegerField;
    Sincronizacao_LogsDatasetultima_sincronizacao: TDateTimeField;
    Sincronizacao_LogsDatasetinicio_sincronizacao: TDateTimeField;
    Sincronizacao_LogsDatasetfim_sincronizacao: TDateTimeField;
    Sincronizacao_LogsDatasetsincronizacao_erro: TStringField;
    Sincronizacao_LogsDatasetinclusao: TDateTimeField;
    Sincronizacao_LogsDatasetalteracao: TDateTimeField;
    Sincronizacao_LogsDatasettempo_sincronizacao: TStringField;
    Sincronizacao_LogsDatasetsincronizacao_rota: TStringField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientSincronizacao_LogsGetLoad(Response: TXDataClientResponse);
    procedure XDataClientSincronizacao_LogsDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientSincronizacao_LogsDeleteError(Error: TXDataClientError);
    procedure Sincronizacao_LogsDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewSincronizacao_LogsEdit: TFViewSincronizacao_LogsEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewSincronizacao_LogsEdit }

procedure TFViewSincronizacao_LogsEdit.btSaveClick(Sender: TObject);
begin
  if Sincronizacao_LogsDataset.State in dsEditModes then
  begin
        Sincronizacao_LogsDataset.Post;
    Sincronizacao_LogsDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewSincronizacao_LogsEdit.btDeleteClick(Sender: TObject);
begin
  if Sincronizacao_LogsDataset.State in dsEditModes then
    Sincronizacao_LogsDataset.Post;
  XDataClientSincronizacao_LogsDelete.Delete(Sincronizacao_LogsDataset.EntitySetName,
    TJSObject(Sincronizacao_LogsDataset.CurrentData));
end;


class function TFViewSincronizacao_LogsEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewSincronizacao_LogsEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewSincronizacao_LogsEdit.InsertEntity;
begin
  Sincronizacao_LogsDataset.Close;
  Sincronizacao_LogsDataset.SetJsonData('{}');
  Sincronizacao_LogsDataset.Open;
  Sincronizacao_LogsDataset.Insert;
end;

class function TFViewSincronizacao_LogsEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewSincronizacao_LogsEdit(AForm).FInserting := AInserting;
    TFViewSincronizacao_LogsEdit(AForm).FId := AId;
    TFViewSincronizacao_LogsEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewSincronizacao_LogsEdit(AForm).InsertEntity
    else
      TFViewSincronizacao_LogsEdit(AForm).LoadEntity;
    TFViewSincronizacao_LogsEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewSincronizacao_LogsEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewSincronizacao_LogsEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Sincronizacao_LogsDataset.Connection.Model.DefaultSchema.FindEntityType(
      Sincronizacao_LogsDataset.EntitySetName
    )
  );
  XDataClientSincronizacao_LogsGet.Get(Sincronizacao_LogsDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewSincronizacao_LogsEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewSincronizacao_LogsEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewSincronizacao_LogsEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewSincronizacao_LogsEdit.XDataClientSincronizacao_LogsGetLoad(Response: TXDataClientResponse);
begin
  Sincronizacao_LogsDataset.Close;
  Sincronizacao_LogsDataset.SetJsonData(Response.Result);
  Sincronizacao_LogsDataset.Open;
  
  Sincronizacao_LogsDataset.Edit;  
end;

procedure TFViewSincronizacao_LogsEdit.XDataClientSincronizacao_LogsDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewSincronizacao_LogsEdit.XDataClientSincronizacao_LogsDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewSincronizacao_LogsEdit.Sincronizacao_LogsDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewSincronizacao_LogsEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewSincronizacao_LogsEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.sincronizacao_logs.form.message');
  lbMessage := TLabel.Create('view.sincronizacao_logs.form.message.label');
  btCloseMessage := TButton.Create('view.sincronizacao_logs.form.message.button');
  btCancel := TButton.Create('view.sincronizacao_logs.form.btBack');
  btSave := TButton.Create('view.sincronizacao_logs.form.btSave');
  btDelete := TButton.Create('view.sincronizacao_logs.form.btDelete');
  lbid := TLabel.Create('view.sincronizacao_logs.form.lbid');
  edid := TDBEdit.Create('view.sincronizacao_logs.form.edid');
  lbaliado_id := TLabel.Create('view.sincronizacao_logs.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.sincronizacao_logs.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.sincronizacao_logs.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.sincronizacao_logs.form.eddata_base_id');
  lbsincronizacao_service_id := TLabel.Create('view.sincronizacao_logs.form.lbsincronizacao_service_id');
  edsincronizacao_service_id := TDBEdit.Create('view.sincronizacao_logs.form.edsincronizacao_service_id');
  lbultima_sincronizacao := TLabel.Create('view.sincronizacao_logs.form.lbultima_sincronizacao');
  edultima_sincronizacao := TDBEdit.Create('view.sincronizacao_logs.form.edultima_sincronizacao');
  lbinicio_sincronizacao := TLabel.Create('view.sincronizacao_logs.form.lbinicio_sincronizacao');
  edinicio_sincronizacao := TDBEdit.Create('view.sincronizacao_logs.form.edinicio_sincronizacao');
  lbfim_sincronizacao := TLabel.Create('view.sincronizacao_logs.form.lbfim_sincronizacao');
  edfim_sincronizacao := TDBEdit.Create('view.sincronizacao_logs.form.edfim_sincronizacao');
  lbsincronizacao_erro := TLabel.Create('view.sincronizacao_logs.form.lbsincronizacao_erro');
  edsincronizacao_erro := TDBEdit.Create('view.sincronizacao_logs.form.edsincronizacao_erro');
  lbinclusao := TLabel.Create('view.sincronizacao_logs.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.sincronizacao_logs.form.edinclusao');
  lbalteracao := TLabel.Create('view.sincronizacao_logs.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.sincronizacao_logs.form.edalteracao');
  lbtempo_sincronizacao := TLabel.Create('view.sincronizacao_logs.form.lbtempo_sincronizacao');
  edtempo_sincronizacao := TDBEdit.Create('view.sincronizacao_logs.form.edtempo_sincronizacao');
  lbsincronizacao_rota := TLabel.Create('view.sincronizacao_logs.form.lbsincronizacao_rota');
  edsincronizacao_rota := TDBEdit.Create('view.sincronizacao_logs.form.edsincronizacao_rota');
  DataSource := TDataSource.Create(Self);
  Sincronizacao_LogsDataset := TXDataWebDataSet.Create(Self);
  Sincronizacao_LogsDatasetid := TIntegerField.Create(Self);
  Sincronizacao_LogsDatasetaliado_id := TIntegerField.Create(Self);
  Sincronizacao_LogsDatasetdata_base_id := TIntegerField.Create(Self);
  Sincronizacao_LogsDatasetsincronizacao_service_id := TIntegerField.Create(Self);
  Sincronizacao_LogsDatasetultima_sincronizacao := TDateTimeField.Create(Self);
  Sincronizacao_LogsDatasetinicio_sincronizacao := TDateTimeField.Create(Self);
  Sincronizacao_LogsDatasetfim_sincronizacao := TDateTimeField.Create(Self);
  Sincronizacao_LogsDatasetsincronizacao_erro := TStringField.Create(Self);
  Sincronizacao_LogsDatasetinclusao := TDateTimeField.Create(Self);
  Sincronizacao_LogsDatasetalteracao := TDateTimeField.Create(Self);
  Sincronizacao_LogsDatasettempo_sincronizacao := TStringField.Create(Self);
  Sincronizacao_LogsDatasetsincronizacao_rota := TStringField.Create(Self);
  XDataClientSincronizacao_LogsGet := TXDataWebClient.Create(Self);
  XDataClientSincronizacao_LogsDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbsincronizacao_service_id.BeforeLoadDFMValues;
  edsincronizacao_service_id.BeforeLoadDFMValues;
  lbultima_sincronizacao.BeforeLoadDFMValues;
  edultima_sincronizacao.BeforeLoadDFMValues;
  lbinicio_sincronizacao.BeforeLoadDFMValues;
  edinicio_sincronizacao.BeforeLoadDFMValues;
  lbfim_sincronizacao.BeforeLoadDFMValues;
  edfim_sincronizacao.BeforeLoadDFMValues;
  lbsincronizacao_erro.BeforeLoadDFMValues;
  edsincronizacao_erro.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbtempo_sincronizacao.BeforeLoadDFMValues;
  edtempo_sincronizacao.BeforeLoadDFMValues;
  lbsincronizacao_rota.BeforeLoadDFMValues;
  edsincronizacao_rota.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Sincronizacao_LogsDataset.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetid.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetaliado_id.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetdata_base_id.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetsincronizacao_service_id.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetultima_sincronizacao.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetinicio_sincronizacao.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetfim_sincronizacao.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetsincronizacao_erro.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetinclusao.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetalteracao.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasettempo_sincronizacao.BeforeLoadDFMValues;
  Sincronizacao_LogsDatasetsincronizacao_rota.BeforeLoadDFMValues;
  XDataClientSincronizacao_LogsGet.BeforeLoadDFMValues;
  XDataClientSincronizacao_LogsDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewSincronizacao_LogsEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 589;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 529;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 529;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 529;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbsincronizacao_service_id.SetParentComponent(Self);
    lbsincronizacao_service_id.Name := 'lbsincronizacao_service_id';
    lbsincronizacao_service_id.Left := 24;
    lbsincronizacao_service_id.Top := 273;
    lbsincronizacao_service_id.Width := 14;
    lbsincronizacao_service_id.Height := 13;
    lbsincronizacao_service_id.Caption := 'sincronizacao_service_id:';
    lbsincronizacao_service_id.Transparent := True;
    edsincronizacao_service_id.SetParentComponent(Self);
    edsincronizacao_service_id.Name := 'edsincronizacao_service_id';
    edsincronizacao_service_id.Left := 221;
    edsincronizacao_service_id.Top := 270;
    edsincronizacao_service_id.Width := 200;
    edsincronizacao_service_id.Height := 21;
    edsincronizacao_service_id.Enabled := True;
    edsincronizacao_service_id.TabOrder := 9;
    edsincronizacao_service_id.Text := 'edsincronizacao_service_id';
    edsincronizacao_service_id.DataField := 'sincronizacao_service_id';
    edsincronizacao_service_id.DataSource := DataSource;
    lbultima_sincronizacao.SetParentComponent(Self);
    lbultima_sincronizacao.Name := 'lbultima_sincronizacao';
    lbultima_sincronizacao.Left := 24;
    lbultima_sincronizacao.Top := 300;
    lbultima_sincronizacao.Width := 14;
    lbultima_sincronizacao.Height := 13;
    lbultima_sincronizacao.Caption := 'ultima_sincronizacao:';
    lbultima_sincronizacao.Transparent := True;
    edultima_sincronizacao.SetParentComponent(Self);
    edultima_sincronizacao.Name := 'edultima_sincronizacao';
    edultima_sincronizacao.Left := 221;
    edultima_sincronizacao.Top := 297;
    edultima_sincronizacao.Width := 200;
    edultima_sincronizacao.Height := 21;
    edultima_sincronizacao.Enabled := True;
    edultima_sincronizacao.TabOrder := 10;
    edultima_sincronizacao.Text := 'edultima_sincronizacao';
    edultima_sincronizacao.DataField := 'ultima_sincronizacao';
    edultima_sincronizacao.DataSource := DataSource;
    lbinicio_sincronizacao.SetParentComponent(Self);
    lbinicio_sincronizacao.Name := 'lbinicio_sincronizacao';
    lbinicio_sincronizacao.Left := 24;
    lbinicio_sincronizacao.Top := 327;
    lbinicio_sincronizacao.Width := 14;
    lbinicio_sincronizacao.Height := 13;
    lbinicio_sincronizacao.Caption := 'inicio_sincronizacao:';
    lbinicio_sincronizacao.Transparent := True;
    edinicio_sincronizacao.SetParentComponent(Self);
    edinicio_sincronizacao.Name := 'edinicio_sincronizacao';
    edinicio_sincronizacao.Left := 221;
    edinicio_sincronizacao.Top := 324;
    edinicio_sincronizacao.Width := 200;
    edinicio_sincronizacao.Height := 21;
    edinicio_sincronizacao.Enabled := True;
    edinicio_sincronizacao.TabOrder := 11;
    edinicio_sincronizacao.Text := 'edinicio_sincronizacao';
    edinicio_sincronizacao.DataField := 'inicio_sincronizacao';
    edinicio_sincronizacao.DataSource := DataSource;
    lbfim_sincronizacao.SetParentComponent(Self);
    lbfim_sincronizacao.Name := 'lbfim_sincronizacao';
    lbfim_sincronizacao.Left := 24;
    lbfim_sincronizacao.Top := 354;
    lbfim_sincronizacao.Width := 14;
    lbfim_sincronizacao.Height := 13;
    lbfim_sincronizacao.Caption := 'fim_sincronizacao:';
    lbfim_sincronizacao.Transparent := True;
    edfim_sincronizacao.SetParentComponent(Self);
    edfim_sincronizacao.Name := 'edfim_sincronizacao';
    edfim_sincronizacao.Left := 221;
    edfim_sincronizacao.Top := 351;
    edfim_sincronizacao.Width := 200;
    edfim_sincronizacao.Height := 21;
    edfim_sincronizacao.Enabled := True;
    edfim_sincronizacao.TabOrder := 12;
    edfim_sincronizacao.Text := 'edfim_sincronizacao';
    edfim_sincronizacao.DataField := 'fim_sincronizacao';
    edfim_sincronizacao.DataSource := DataSource;
    lbsincronizacao_erro.SetParentComponent(Self);
    lbsincronizacao_erro.Name := 'lbsincronizacao_erro';
    lbsincronizacao_erro.Left := 24;
    lbsincronizacao_erro.Top := 381;
    lbsincronizacao_erro.Width := 14;
    lbsincronizacao_erro.Height := 13;
    lbsincronizacao_erro.Caption := 'sincronizacao_erro:';
    lbsincronizacao_erro.Transparent := True;
    edsincronizacao_erro.SetParentComponent(Self);
    edsincronizacao_erro.Name := 'edsincronizacao_erro';
    edsincronizacao_erro.Left := 221;
    edsincronizacao_erro.Top := 378;
    edsincronizacao_erro.Width := 200;
    edsincronizacao_erro.Height := 21;
    edsincronizacao_erro.Enabled := True;
    edsincronizacao_erro.TabOrder := 13;
    edsincronizacao_erro.Text := 'edsincronizacao_erro';
    edsincronizacao_erro.DataField := 'sincronizacao_erro';
    edsincronizacao_erro.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 408;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 405;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 14;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 435;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 432;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 15;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbtempo_sincronizacao.SetParentComponent(Self);
    lbtempo_sincronizacao.Name := 'lbtempo_sincronizacao';
    lbtempo_sincronizacao.Left := 24;
    lbtempo_sincronizacao.Top := 462;
    lbtempo_sincronizacao.Width := 14;
    lbtempo_sincronizacao.Height := 13;
    lbtempo_sincronizacao.Caption := 'tempo_sincronizacao:';
    lbtempo_sincronizacao.Transparent := True;
    edtempo_sincronizacao.SetParentComponent(Self);
    edtempo_sincronizacao.Name := 'edtempo_sincronizacao';
    edtempo_sincronizacao.Left := 221;
    edtempo_sincronizacao.Top := 459;
    edtempo_sincronizacao.Width := 200;
    edtempo_sincronizacao.Height := 21;
    edtempo_sincronizacao.Enabled := True;
    edtempo_sincronizacao.TabOrder := 16;
    edtempo_sincronizacao.Text := 'edtempo_sincronizacao';
    edtempo_sincronizacao.DataField := 'tempo_sincronizacao';
    edtempo_sincronizacao.DataSource := DataSource;
    lbsincronizacao_rota.SetParentComponent(Self);
    lbsincronizacao_rota.Name := 'lbsincronizacao_rota';
    lbsincronizacao_rota.Left := 24;
    lbsincronizacao_rota.Top := 489;
    lbsincronizacao_rota.Width := 14;
    lbsincronizacao_rota.Height := 13;
    lbsincronizacao_rota.Caption := 'sincronizacao_rota:';
    lbsincronizacao_rota.Transparent := True;
    edsincronizacao_rota.SetParentComponent(Self);
    edsincronizacao_rota.Name := 'edsincronizacao_rota';
    edsincronizacao_rota.Left := 221;
    edsincronizacao_rota.Top := 486;
    edsincronizacao_rota.Width := 200;
    edsincronizacao_rota.Height := 21;
    edsincronizacao_rota.Enabled := True;
    edsincronizacao_rota.TabOrder := 17;
    edsincronizacao_rota.Text := 'edsincronizacao_rota';
    edsincronizacao_rota.DataField := 'sincronizacao_rota';
    edsincronizacao_rota.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Sincronizacao_LogsDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Sincronizacao_LogsDataset.SetParentComponent(Self);
    Sincronizacao_LogsDataset.Name := 'Sincronizacao_LogsDataset';
    Sincronizacao_LogsDataset.AfterApplyUpdates := Sincronizacao_LogsDatasetAfterApplyUpdates;
    Sincronizacao_LogsDataset.EntitySetName := 'Sincronizacao_Logs';
    Sincronizacao_LogsDataset.Connection := DMConnection.ApiConnection;
    Sincronizacao_LogsDataset.Left := 176;
    Sincronizacao_LogsDataset.Top := 8;
    Sincronizacao_LogsDatasetid.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetid.Name := 'Sincronizacao_LogsDatasetid';
    Sincronizacao_LogsDatasetid.FieldName := 'id';
    Sincronizacao_LogsDatasetid.Required := True;
    Sincronizacao_LogsDatasetaliado_id.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetaliado_id.Name := 'Sincronizacao_LogsDatasetaliado_id';
    Sincronizacao_LogsDatasetaliado_id.FieldName := 'aliado_id';
    Sincronizacao_LogsDatasetaliado_id.Required := True;
    Sincronizacao_LogsDatasetdata_base_id.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetdata_base_id.Name := 'Sincronizacao_LogsDatasetdata_base_id';
    Sincronizacao_LogsDatasetdata_base_id.FieldName := 'data_base_id';
    Sincronizacao_LogsDatasetdata_base_id.Required := True;
    Sincronizacao_LogsDatasetsincronizacao_service_id.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetsincronizacao_service_id.Name := 'Sincronizacao_LogsDatasetsincronizacao_service_id';
    Sincronizacao_LogsDatasetsincronizacao_service_id.FieldName := 'sincronizacao_service_id';
    Sincronizacao_LogsDatasetsincronizacao_service_id.Required := True;
    Sincronizacao_LogsDatasetultima_sincronizacao.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetultima_sincronizacao.Name := 'Sincronizacao_LogsDatasetultima_sincronizacao';
    Sincronizacao_LogsDatasetultima_sincronizacao.FieldName := 'ultima_sincronizacao';
    Sincronizacao_LogsDatasetultima_sincronizacao.Required := False;
    Sincronizacao_LogsDatasetinicio_sincronizacao.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetinicio_sincronizacao.Name := 'Sincronizacao_LogsDatasetinicio_sincronizacao';
    Sincronizacao_LogsDatasetinicio_sincronizacao.FieldName := 'inicio_sincronizacao';
    Sincronizacao_LogsDatasetinicio_sincronizacao.Required := False;
    Sincronizacao_LogsDatasetfim_sincronizacao.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetfim_sincronizacao.Name := 'Sincronizacao_LogsDatasetfim_sincronizacao';
    Sincronizacao_LogsDatasetfim_sincronizacao.FieldName := 'fim_sincronizacao';
    Sincronizacao_LogsDatasetfim_sincronizacao.Required := False;
    Sincronizacao_LogsDatasetsincronizacao_erro.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetsincronizacao_erro.Name := 'Sincronizacao_LogsDatasetsincronizacao_erro';
    Sincronizacao_LogsDatasetsincronizacao_erro.FieldName := 'sincronizacao_erro';
    Sincronizacao_LogsDatasetsincronizacao_erro.Required := False;
    Sincronizacao_LogsDatasetsincronizacao_erro.Size := 65536;
    Sincronizacao_LogsDatasetinclusao.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetinclusao.Name := 'Sincronizacao_LogsDatasetinclusao';
    Sincronizacao_LogsDatasetinclusao.FieldName := 'inclusao';
    Sincronizacao_LogsDatasetinclusao.Required := False;
    Sincronizacao_LogsDatasetalteracao.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetalteracao.Name := 'Sincronizacao_LogsDatasetalteracao';
    Sincronizacao_LogsDatasetalteracao.FieldName := 'alteracao';
    Sincronizacao_LogsDatasetalteracao.Required := False;
    Sincronizacao_LogsDatasettempo_sincronizacao.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasettempo_sincronizacao.Name := 'Sincronizacao_LogsDatasettempo_sincronizacao';
    Sincronizacao_LogsDatasettempo_sincronizacao.FieldName := 'tempo_sincronizacao';
    Sincronizacao_LogsDatasettempo_sincronizacao.Required := False;
    Sincronizacao_LogsDatasettempo_sincronizacao.Size := 0;
    Sincronizacao_LogsDatasetsincronizacao_rota.SetParentComponent(Sincronizacao_LogsDataset);
    Sincronizacao_LogsDatasetsincronizacao_rota.Name := 'Sincronizacao_LogsDatasetsincronizacao_rota';
    Sincronizacao_LogsDatasetsincronizacao_rota.FieldName := 'sincronizacao_rota';
    Sincronizacao_LogsDatasetsincronizacao_rota.Required := False;
    Sincronizacao_LogsDatasetsincronizacao_rota.Size := 0;
    XDataClientSincronizacao_LogsGet.SetParentComponent(Self);
    XDataClientSincronizacao_LogsGet.Name := 'XDataClientSincronizacao_LogsGet';
    XDataClientSincronizacao_LogsGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientSincronizacao_LogsGet, Self, 'OnLoad', 'XDataClientSincronizacao_LogsGetLoad');
    XDataClientSincronizacao_LogsGet.Left := 64;
    XDataClientSincronizacao_LogsGet.Top := 8;
    XDataClientSincronizacao_LogsDelete.SetParentComponent(Self);
    XDataClientSincronizacao_LogsDelete.Name := 'XDataClientSincronizacao_LogsDelete';
    XDataClientSincronizacao_LogsDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientSincronizacao_LogsDelete, Self, 'OnLoad', 'XDataClientSincronizacao_LogsDeleteLoad');
    SetEvent(XDataClientSincronizacao_LogsDelete, Self, 'OnError', 'XDataClientSincronizacao_LogsDeleteError');
    XDataClientSincronizacao_LogsDelete.Left := 64;
    XDataClientSincronizacao_LogsDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbsincronizacao_service_id.AfterLoadDFMValues;
    edsincronizacao_service_id.AfterLoadDFMValues;
    lbultima_sincronizacao.AfterLoadDFMValues;
    edultima_sincronizacao.AfterLoadDFMValues;
    lbinicio_sincronizacao.AfterLoadDFMValues;
    edinicio_sincronizacao.AfterLoadDFMValues;
    lbfim_sincronizacao.AfterLoadDFMValues;
    edfim_sincronizacao.AfterLoadDFMValues;
    lbsincronizacao_erro.AfterLoadDFMValues;
    edsincronizacao_erro.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbtempo_sincronizacao.AfterLoadDFMValues;
    edtempo_sincronizacao.AfterLoadDFMValues;
    lbsincronizacao_rota.AfterLoadDFMValues;
    edsincronizacao_rota.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Sincronizacao_LogsDataset.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetid.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetaliado_id.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetdata_base_id.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetsincronizacao_service_id.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetultima_sincronizacao.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetinicio_sincronizacao.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetfim_sincronizacao.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetsincronizacao_erro.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetinclusao.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetalteracao.AfterLoadDFMValues;
    Sincronizacao_LogsDatasettempo_sincronizacao.AfterLoadDFMValues;
    Sincronizacao_LogsDatasetsincronizacao_rota.AfterLoadDFMValues;
    XDataClientSincronizacao_LogsGet.AfterLoadDFMValues;
    XDataClientSincronizacao_LogsDelete.AfterLoadDFMValues;
  end;
end;

end.
